import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function ProfileHome() {
    return (
        <>
     <img src="../../images/jpg/comingsoon.png" alt="" className="img-fluid"  />
          
        </>
    )
}